import axios from 'axios';
import { setHeader } from '.';

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

/**
 * Fetches all Linktivity categories
 * @returns a promise of the axios response
 */
export const fetchCategories = () => {
  return axios.get(`${BASE_URL}/linktivities/categories`);
};

/**
 * Fetches Specific Category
 * @param {string} id - The category id
 * @returns a promise of the axios response
 */
export const fetchCategoryList = (id) => {
  return axios.get(`${BASE_URL}/linktivities/listbycategory/${id}`);
};

/**
 * Fetches a specific linktivity activity preview by linktivity id
 * @param {string} linktivityId - The linktivity id
 * @returns a promise of the axios response
 */
export const fetchLinktivityPreview = (linktivityId) => {
  return axios.get(`${BASE_URL}/linktivities/preview/${linktivityId}`);
};

/**
 * Fetches a full linktivity activity by linktivity id
 * @param {string} linktivityId - The linktivity id
 * @returns a promise of the axios response
 */
export const fetchLinktivity = async (linktivityId) => {
  const request = await setHeader(axios);
  return request.get(`${BASE_URL}/linktivities/full/${linktivityId}`);
};

/**
 * Fetches New and Featured LINKtivities
 * @returns a promise of the axios response
 */
export const fetchNewAndFeaturedLTVs = () => {
  return axios.get(`${BASE_URL}/linktivities/listnewfeatured/`);
};
